const COMPANY_ID_KEY = "__company_id";
const CUSTOMER_GROUP_KEY = "__from_cart_customer_group";
const CAMPAIGN_ID_KEY = "__iterable_campaign_id";
const STOREFRONT_CART_ID_KEY = "__storefront_cart_id";

const getIterableCampaignId = () => {
  const params = new URLSearchParams(window.location.search);
  const campaignId = params.get("iterable_campaign");

  if (campaignId && /^\d+$/.test(campaignId)) {
    return campaignId;
  }

  return null;
};

const updateCompanyIdCartAttribute = () => {
  window.loadInitialCart.then(() => {
    const targets = [
      {
        expected: window.theme.company_id,
        key: COMPANY_ID_KEY,
      },
      {
        expected: window.theme.customer_group,
        key: CUSTOMER_GROUP_KEY,
      },
      // This attribute is added automatically by persistent cart when a cart is created but
      // check to confirm it hasn't been removed inadvertently.
      // This is used on the back end to close persistent carts after order is placed so is important.
      {
        expected: window.cartData.id,
        key: STOREFRONT_CART_ID_KEY,
      },
    ];

    const iterableCampaignId = getIterableCampaignId();

    if (iterableCampaignId) {
      targets.push({
        expected: iterableCampaignId,
        key: CAMPAIGN_ID_KEY,
      });
    }

    const updateRequired = targets.some(({ expected, key }) => {
      const saved = window.cartData?.attributes?.[key] || "";
      return saved !== expected;
    });

    if (updateRequired) {
      const attributes = Object.fromEntries(
        targets.map(({ expected, key }) => [key, expected]),
      );
      window.updateCart({
        attributes,
      });
    }
  });
};

updateCompanyIdCartAttribute();

document.addEventListener("cart:updated", updateCompanyIdCartAttribute);
